import React from "react";

const Line = () => {
    return (
        <div className="no-print  items-center py-8">
            <div className="flex-grow h-1 bg-gradient-to-r from-[#44a5e4] to-blue-500/50 rounded-full"></div>
            <span className="mx-4 text-blue-500 text-lg font-bold">✦</span>
            <div className="flex-grow h-1 bg-gradient-to-r from-blue-500/50 to-[#44a5e4] rounded-full"></div>
        </div>
    );
}

export default Line;